import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from './_authenticated'
import { OnboardingFindFriends } from '@/pages/onboarding/OnboardingFindFriends'

/**
 * /sync-contacts - Find friends from contacts (standalone, accessible from menu)
 */
export const syncContactsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/sync-contacts',
  component: () => <OnboardingFindFriends isOnboarding={false} />,
})
